import { refs, domReady } from '../modules/utils.js';
import { test as testMedia } from '../modules/match-media.js';

class FooterBar extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);

    if (testMedia('small')) {
      const scrollTop = this.querySelector('scroll-top');
      const companyInfo = this.querySelector('.footerbar-company');
      if (scrollTop && companyInfo) {
        companyInfo.appendChild(scrollTop);
      }
    }
  }
}

customElements.define('footer-bar', FooterBar);
